import { capitalize } from 'helpers/utils/strings';


export const SEARCH_INPUT_PLACEHOLDER = `Search on ${capitalize(__PLATFORM__)}`;
export const YOUR_EMAIL = 'Your Email';
